import { render } from "./select.vue?vue&type=template&id=4675eb00&ts=true"
import script from "./select.vue?vue&type=script&lang=ts"
export * from "./select.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__